import SingleProblemModal from './SingleProblemModal';

export default SingleProblemModal;
